import autosize from 'autosize';

import { isSet } from '../utils/isSet';
import { loadResourceFile } from "../functions/loadResourceFile";

import { Layer } from "../classes/Layer";

import EmblaCarousel from 'embla-carousel';
import ClassNames from 'embla-carousel-class-names';
import {
  addThumbBtnsClickHandlers,
  addToggleThumbBtnsActive
} from '../functions/emblaCarouselThumbnailButtons';
import { addPrevNextBtnsClickHandlers } from '../functions/emblaCarouselControls';
import { setupLazyLoadImage } from '../functions/emblaCarouselLazyLoad';
import { setupLazyPlayVideo } from '../functions/emblaCarouselLazyPlayVideo';
import { setupGalleryController } from '../functions/emblaCarouselGalleryController';

class Product {
    /** @type {Number} */
    #animationOpenCount;

    /** @type {Number} */
    #animationCloseCount;

    constructor (domNode) {
        this.root = domNode;
        this.grid = this.root.querySelector('.product__grid');
        this.galleryCol = this.root.querySelector('.product__col--gallery');
        this.contentCol = this.root.querySelector('.product__col--content');
        this.fullscreenToggleElms = this.root.querySelectorAll('.product__fullscreen--js');
        this.gallery360ToggleElms = this.root.querySelectorAll('.product__3d--js');
        this.dismissControllerToggleElm = this.root.querySelector('.dismiss-controller-reminder--js');
        this.emblaElm = this.root.querySelector('.embla--js');

        this.splitscreenClassname = 'is-splitscreen';
        this.fullscreenClassname = 'is-fullscreen';

        this.isSplitscreen = true;
        this.isFullscreen = true;

        this.init();
    }

    init(){
        this.addEventListeners();
        this.init__panels();
        this.init__embla();
        this.init__Jquery();
    }

    init__embla(){
        this.mainViewportNode = this.emblaElm.querySelector('.embla__viewport');
        if(!isSet(this.mainViewportNode)) return;

        this.thumbViewportNode = this.emblaElm.querySelector('.embla-thumbs__viewport');
        if(!isSet(this.thumbViewportNode)) return;

        this.options = {
            containScroll: 'keepSnaps',
            loop: true,
            inViewThreshold: 0.5
        }
        this.options__thumb = {
            containScroll: 'keepSnaps',
            loop: true,
            dragFree: true,
            align: "center"
        }

        this.emblaApiMain = EmblaCarousel(
            this.mainViewportNode, 
            this.options,
            [
                ClassNames()
            ]
        );
        this.emblaApiThumb = EmblaCarousel(
            this.thumbViewportNode, 
            this.options__thumb,
            [
                ClassNames()
            ]
        );

        const removeThumbBtnsClickHandlers = addThumbBtnsClickHandlers(
            this.emblaApiMain,
            this.emblaApiThumb
        )
        const removeToggleThumbBtnsActive = addToggleThumbBtnsActive(
            this.emblaApiMain,
            this.emblaApiThumb
        )

        const initLazyPlayVideo = setupLazyPlayVideo(
            this.emblaApiMain
        )

        const toggleActiveWhenScrollable = () => {
            const isScrollable = this.emblaApiThumb.internalEngine().scrollSnaps.length > 1
            this.emblaApiThumb.reInit({ active: isScrollable })
        }

        this.emblaApiMain
            .on('destroy', removeThumbBtnsClickHandlers)
            .on('destroy', removeToggleThumbBtnsActive)

        this.emblaApiThumb
            .on('destroy', removeThumbBtnsClickHandlers)
            .on('destroy', removeToggleThumbBtnsActive)
            .on('resize', toggleActiveWhenScrollable)

        this.emblaApiMain
            .on('init', initLazyPlayVideo)
            .on('init', setupGalleryController)
            .on('reInit', initLazyPlayVideo)
            .on('slidesInView', initLazyPlayVideo)

        toggleActiveWhenScrollable();
    }

    init__panels(){
        this.panels = document.querySelectorAll(".product-panel--js");

        this.panels.forEach( (panelElm) => {
            let panel = new Layer(
                panelElm,
                {
                    disableScroll: (window.innerWidth > 920) ? false : true,
                    awaitCloseAnimation: true,
                    awaitOpenAnimation: true,
                    closeOnBackgroundClick: (window.innerWidth > 920) ? false : true,
                    closeOnEscClick: (window.innerWidth > 920) ? false : true
                }
            );

            if(panel.id === 'layer--tab-panel--wattage'){
                panelElm.addEventListener('layerbeforeopen', function(){
                    loadResourceFile( herschel_theme_locale_strings.themedir + "/wattage-calculator/assets/js/app.min.js", "js");
                    loadResourceFile( herschel_theme_locale_strings.themedir + "/wattage-calculator/assets/css/bootstrap-custom.css", "css");
                    setTimeout(function() { autosize(document.querySelector('#XLEW_1_16_1')); }, 200);
                });
            }

            if(panel.id === 'layer--tab-panel--poa'){
                panelElm.addEventListener('layerbeforeopen', function(){
                    const filename = 'https://form.jotform.com/jsform/243373621638055';

                    const formContainerTargetElm = document.querySelector('.poa-enquiry-form--js');

                    if(!isSet(formContainerTargetElm)) return;

                    let fileref = document.createElement('script');
                    fileref.setAttribute("type","text/javascript");
                    fileref.setAttribute("src", filename);

                    if (window.filesadded.indexOf("["+filename+"]") == -1){
                        formContainerTargetElm.appendChild(fileref);
                        window.filesadded += "["+filename+"]";
                    } 

                });
            }

            let gridElm = this.grid;

            panelElm.addEventListener('layerbeforeopen', () => {
                if(window.innerWidth > 920) gridElm.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
            });

            panelElm.addEventListener('layerafteropen', () => {
                const activeLayers = window.store.activeLayers;
                const currentlyActiveLayer = window.store.activeLayer;
                activeLayers.forEach((activeLayer) => {
                    if(currentlyActiveLayer === activeLayer) return;

                    document.getElementById(activeLayer).classList.add('is-position-absolute');
                });
            });

            panelElm.addEventListener('layerbeforeclose', () => {
                const currentlyActiveLayer = window.store.activeLayer;

                if(!isSet(currentlyActiveLayer)) return;
                
                document.getElementById(currentlyActiveLayer).classList.remove('is-position-absolute');
            });

            panelElm.addEventListener('layerafterclose', () => {
            });
        });
    }


    init__Jquery(){
        //jQuery here
        jQuery( function( $ ) {
            $(document).on('change', '.variation__radio-input input', function() {
                $('.variation__radio-input input:checked' ).each( function(index, element) {
                    const radio = $(element)
                    const radioName = radio.attr('name')
                    const radioValue  = radio.attr('value')
                    $('select[id="' + radioName + '"]').val(radioValue).trigger('change');
                });
            });

            $(document).on( "change", '.variations_form select', function (e) {
                let attributeName = jQuery(this).attr('id');
                let selectedValue = jQuery(this).val();

                replace_variation_cart_fragments(attributeName, selectedValue);
            } );

            $(document).on('show_variation', 'form.variations_form', function(event, variation) {
                $( ".single_variation_wrap" ).addClass('is-valid');
            });

            $(document).on('reset_data', 'form.variations_form', function(event, variation) {
                $( ".single_variation_wrap" ).removeClass('is-valid');
            } );

            $(document.body).on( "wc_fragments_loaded", function (event, variation) {
                $('.variation__radio-input input').prop('checked', false);
                $('.variations_form select').val("").prop('selectedIndex', -1);

                $('.variations_form select').each( function( index, element ) {
                    const select = $(element)
                    let attributeName = select.attr('id');
                    reset_variation_cart_fragments(attributeName);
                });

                $(".single_variation_wrap").removeClass('is-valid');

                $('#controller-reminder').removeClass('is-hidden');
            });
        })

        //Inner Helper Functions
        function replace_variation_cart_fragments(attributeName, selectedValue){
            const existingVariationButtonElm = document.querySelector('.variation__selector .variation__button[data-attribute-name="' + attributeName + '"]');

            const template = document.getElementById('variation-templates--' + attributeName);
            if(!isSet(template)) return;
            
            const templateOptions = Array.from(template.content.cloneNode(true).children);
            let newVariationButtonElm;
            
            templateOptions.forEach((templateOption) => {
                const name = templateOption.attributes.getNamedItem("data-attribute-name");
                const value = templateOption.attributes.getNamedItem("data-attribute-value");

                if(isSet(name) && isSet(value)){
                    if(isSet(name.value) && name.value === attributeName && isSet(value.value) && value.value === selectedValue){
                        newVariationButtonElm = templateOption;
                    }
                }
            });

            existingVariationButtonElm.replaceWith(newVariationButtonElm);
        }

        function reset_variation_cart_fragments(attributeName){
            const existingVariationButtonElm = document.querySelector('.variation__selector .variation__button[data-attribute-name="' + attributeName + '"]');

            const template = document.getElementById('variation-templates--' + attributeName);
            if(!isSet(template)) return;

            const templateOptions = Array.from(template.content.cloneNode(true).children);
            let newVariationButtonElm;
            
            templateOptions.forEach((templateOption) => {
                const name = templateOption.attributes.getNamedItem("data-attribute-default");

                if(isSet(name)){
                    if(isSet(name.value) && name.value === attributeName){
                        newVariationButtonElm = templateOption;
                        newVariationButtonElm.removeAttribute('data-attribute-default');
                        newVariationButtonElm.setAttribute('data-attribute-name', attributeName);
                        
                    }
                }
            });

            existingVariationButtonElm.replaceWith(newVariationButtonElm);
        }
    }

    addEventListeners(){
        this.handleFullscreenToggleClickBound = this.handleFullscreenToggleClick.bind(this);
        this.fullscreenToggleElms.forEach((fullscreenToggleElm) => {
            fullscreenToggleElm.addEventListener(
                'click', 
                this.handleFullscreenToggleClickBound
            );
        });

        this.handleGallery360ToggleClickBound = this.handleGallery360ToggleClick.bind(this);
        this.gallery360ToggleElms.forEach((gallery360ToggleElm) => {
            gallery360ToggleElm.addEventListener(
                'click', 
                this.handleGallery360ToggleClickBound
            );
        });

        if(isSet(this.dismissControllerToggleElm)){
            this.handleControllerDismissClickBound = this.handleControllerDismissClick.bind(this);
            this.dismissControllerToggleElm.addEventListener(
                'click', 
                this.handleControllerDismissClickBound
            );
        }
    }

    handleControllerDismissClick(e){
        if (!isSet(Cookies)) return;

        Cookies.set('herschel_dismissed_controller_reminder', '1', { expires: 2, path: '/' });

        const controllerReminderElm = document.getElementById('controller-reminder');

        if(isSet(controllerReminderElm)) controllerReminderElm.remove();
    }

    handleGallery360ToggleClick(e){
        const galleryType = this.galleryCol.dataset.galleryType;

        const magic360Elm = this.galleryCol.querySelector('.Magic360');

        switch(galleryType){
            case 'carousel':
                this.galleryCol.dataset.galleryType = '360';
                break;
            case '360':
                this.galleryCol.dataset.galleryType = 'carousel';
                break;
            default:
                break;
        }
    }

    handleFullscreenToggleClick(e){
        let contentHeight = this.contentCol.offsetHeight;
        let contentWidth = this.contentCol.offsetWidth;
        
        if (this.isSplitscreen) {
            this.grid.scrollIntoView({ behavior: "instant", block: "start", inline: "nearest" });
            this.grid.style.setProperty('--content-height', contentHeight + 'px');
            this.grid.style.setProperty('--content-width', contentWidth + 'px');
            this.goFullscreen(e);
        } else {
            this.grid.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
            this.goSplitscreen(e);
        }
    }

    goFullscreen(e){
        this.#animationOpenCount = 0;
        this.#animationCloseCount = 0;

        if (this.isSplitscreen) {
            this.root.classList.add('is-animating', 'is-animating--closing');
            this.isClosing = true;
            this.isAnimating = true;

            this.handleFullscreenAnimationClosingStartBound = this.handleFullscreenAnimationClosingStart.bind(this);
            this.handleFullscreenAnimationClosingEndBound = this.handleFullscreenAnimationClosingEnd.bind(this);

            document.addEventListener('animationstart', this.handleFullscreenAnimationClosingStartBound);
            document.addEventListener('animationend', this.handleFullscreenAnimationClosingEndBound);
        }
    }

    goSplitscreen(e){
        this.#animationOpenCount = 0;
        this.#animationCloseCount = 0;

        if(this.isFullscreen){
            this.contentCol.setAttribute('aria-hidden', 'false');
            this.root.classList.remove(this.fullscreenClassname);

            this.handleFullscreenAnimationOpeningStartBound = this.handleFullscreenAnimationOpeningStart.bind(this);
            this.handleFullscreenAnimationOpeningEndBound = this.handleFullscreenAnimationOpeningEnd.bind(this);

            document.addEventListener('animationstart', this.handleFullscreenAnimationOpeningStartBound);
            document.addEventListener('animationend', this.handleFullscreenAnimationOpeningEndBound);

            // @ts-ignore
            this.root.classList.add('is-animating', 'is-animating--opening');
            this.isOpening = true;
            this.isAnimating = true;
        }
    }

    handleFullscreenAnimationOpeningStart(e){
        if(e.target === this.grid || this.root.contains(e.target)) this.#animationOpenCount++;
    }

    handleFullscreenAnimationOpeningEnd(e){
        if(e.target === this.grid || this.root.contains(e.target)){
            this.#animationOpenCount--;

            if (this.#animationOpenCount !== 0) return;

            this.root.classList.remove('is-animating', 'is-animating--opening');
            this.isSplitscreen = true;
            this.isFullscreen = false;

            if(this.handleFullscreenAnimationOpeningStartBound) document.removeEventListener('animationstart', this.handleFullscreenAnimationOpeningStartBound);
            if(this.handleFullscreenAnimationOpeningEndBound) document.removeEventListener('animationend', this.handleFullscreenAnimationOpeningEndBound);
        }
    }

    handleFullscreenAnimationClosingStart(e){
        if(e.target === this.grid || this.root.contains(e.target)) this.#animationCloseCount++;
    }

    handleFullscreenAnimationClosingEnd(e){
        if(e.target === this.grid || this.root.contains(e.target)){
            this.#animationOpenCount = 0;
            this.#animationCloseCount = 0;
            // @ts-ignore
            this.root.classList.remove('is-animating', 'is-animating--closing');
            this.contentCol.setAttribute('aria-hidden', 'true');
            this.root.classList.add(this.fullscreenClassname);
            this.isSplitscreen = false;
            this.isFullscreen = true;
            this.isClosing = false;
            this.isAnimating = false;
            

            if(this.handleFullscreenAnimationClosingStartBound) document.removeEventListener('animationstart', this.handleFullscreenAnimationClosingStartBound);
            if(this.handleFullscreenAnimationClosingEndBound) document.removeEventListener('animationend', this.handleFullscreenAnimationClosingEndBound);
        }
    }
}

exports.Product = Product